import React, { useState, useEffect } from 'react';
import { Pie, Line, Bar, HorizontalBar,} from 'react-chartjs-2';

import { GMMain } from './GraphMasterDouble.style';

import ReactWordcloud from 'react-wordcloud';

import Chart from "react-google-charts";

const GraphMasterDouble = (props) => {
  let { data, special } = props;
  
  
  let checkGraphKind = (type) => {
    let labelArray = [];
    let dataArray = [];
    let dataArray2 = [];
    let dataArray3 = [];
    let price_new = null;
    let verde = [];
    let amarillo = [];
    let rojo = [];
    let price_list = [];
    let mapData = null;
    let mapData2 = null;
    let Conteo = null;
    let mapInfo = {};
    let mapInfo2 = {};
    let mapInfo3 = {};
    let mapInfo4 = {};
    let word = {}
    let data = null; 
    let options = null; 
    let limit = 8
    let getMapData = null;
    if(type){
      switch(type.name) {
        case 'EmocionesProm_Sexo':
          let f = []
          let m = []

          for(let x in type.data){
            labelArray.push(x)
            if(x === "F"){
              for(let y in type.data[x]){
              f.push(Number(type.data[x][y]).toFixed(4))
              }
            } else if(x === "M"){
              for(let y in type.data[x]){
                m.push(Number(type.data[x][y]).toFixed(4))
                }
            } else return
          }
          data = {
            labels: [...labelArray],
            datasets: [
              {
              label: 'neg',
              backgroundColor: '#F2D7E1',
              borderColor: '#F2D7E1',
              borderWidth: 1,
              stack: '1',
              hoverBackgroundColor: '#FFE0E6',
              hoverBorderColor: '#FFE0E6',
              data: [Number(f[0]), Number(m[0])]
            },
            {
              label: 'neu',
              backgroundColor: '#BDBCC3',
              borderColor: '#BDBCC3',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFF5DD',
              hoverBorderColor: '#FFF5DD',
              data: [Number(f[2]), Number(m[2])],
            },
            {
              label: 'pos',
              backgroundColor: '#CCF1F0',
              borderColor: '#CCF1F0',
              borderWidth: 1,
              stack: '2',
              hoverBackgroundColor: '#DBF2F2',
              hoverBorderColor: '#DBF2F2',
              data: [Number(f[1]), Number(m[1])]
            }
            ]
          }
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: false,
            legend: {
              labels: {
                fontSize: 10
              }
          },
            scales: {
              xAxes: [{
                stacked: true,
                gridLines: {
                  offsetGridLines: true
                },
                ticks: {
                  scaleBeginAtZero: false,
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Sexo'
                }
              }],
              yAxes: [{
                stacked: false,
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Proporción del total'
                }
              }]
            }
          }
        return <Bar data={data} options={options}/>
        case 'EmocionesProm_GrupoEdad':
          for(let x in type.data){
            labelArray.push(x)
            dataArray.push(type.data[x])
          }
          data = {
            labels: [labelArray[3], labelArray[1], labelArray[0], labelArray[2]],
            datasets: [
              {
              label: 'neg',
              backgroundColor: '#F2D7E1',
              borderColor: '#F2D7E1',
              borderWidth: 1,
              stack: '1',
              hoverBackgroundColor: '#FFE0E6',
              hoverBorderColor: '#FFE0E6',
              data: [dataArray[3].neg, dataArray[1].neg, dataArray[0].neg, dataArray[2].neg]
            },
            {
              label: 'neu',
              backgroundColor: '#BDBCC3',
              borderColor: '#BDBCC3',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFF5DD',
              hoverBorderColor: '#FFF5DD',
              data: [dataArray[3].neu, dataArray[1].neu, dataArray[0].neu, dataArray[2].neu],
            },
            {
              label: 'pos',
              backgroundColor: '#CCF1F0',
              borderColor: '#CCF1F0',
              borderWidth: 1,
              stack: '2',
              hoverBackgroundColor: '#DBF2F2',
              hoverBorderColor: '#DBF2F2',
              data: [dataArray[3].pos, dataArray[1].pos, dataArray[0].pos, dataArray[2].pos]
            }
            ]
          }
          
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: false,
            legend: {
              labels: {
                fontSize: 10
              }
            },
            scales: {
              xAxes: [{
                stacked: true,
                gridLines: {
                  offsetGridLines: true
                },
                ticks: {
                  scaleBeginAtZero: false,
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Edad'
                }
              }],
              yAxes: [{
                stacked: false,
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Proporción del total'
                }
              }]
            }
          } 
        return <Bar data={data} options={options}/>
      case 'EmocionesProm_Region':
          for(let x in type.data){
            labelArray.push(x)
            dataArray.push(type.data[x])
          }
          data = {
            labels: [labelArray[3], labelArray[4], labelArray[1], labelArray[0], labelArray[2]],
            datasets: [
              {
                label: 'neg',
                backgroundColor: '#F2D7E1',
                borderColor: '#F2D7E1',
                borderWidth: 1,
                stack: '1',
                hoverBackgroundColor: '#FFE0E6',
                hoverBorderColor: '#FFE0E6',
                data: [dataArray[3].neg, dataArray[4].neg, dataArray[1].neg, dataArray[0].neg, dataArray[2].neg]
            },
            {
              label: 'neu',
              backgroundColor: '#BDBCC3',
              borderColor: '#BDBCC3',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFF5DD',
              hoverBorderColor: '#FFF5DD',
              data: [dataArray[3].neu, dataArray[4].neu, dataArray[1].neu, dataArray[0].neu, dataArray[2].neu],
            },
            {
              label: 'pos',
              backgroundColor: '#CCF1F0',
              borderColor: '#CCF1F0',
              borderWidth: 1,
              stack: '2',
              hoverBackgroundColor: '#DBF2F2',
              hoverBorderColor: '#DBF2F2',
              data: [dataArray[3].pos, dataArray[4].pos, dataArray[1].pos, dataArray[0].pos, dataArray[2].pos]
            }
            ]}
            options = {
              maintainAspectRatio: false,
              responsive: true,
              borderSkipped: false,
              legend: {
                labels: {
                  fontSize: 10
                }
              },
              scales: {
                xAxes: [{
                  stacked: true,
                  gridLines: {
                    offsetGridLines: true
                  },
                  ticks: {
                    scaleBeginAtZero: false,
                    fontSize: 11
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Región'
                  }
                }],
                yAxes: [{
                  stacked: false,
                  ticks: {
                    fontSize: 11
                  },
                  scaleLabel: {
                    display: true,
                    labelString: 'Proporción del total'
                  }
                }]
              }
            } 
        return <Bar data={data} options={options} />
        case 'EmocionesProm_Rango_Ingreso':
          for(let x in type.data){
            labelArray.push(x)
            dataArray.push(type.data[x])
          }

          data = {
            labels: [labelArray[0], labelArray[1], labelArray[2], labelArray[3]],
            datasets: [
              {
                label: 'neg',
                backgroundColor: '#F2D7E1',
                borderColor: '#F2D7E1',
                borderWidth: 1,
                stack: '1',
                hoverBackgroundColor: '#FFE0E6',
                hoverBorderColor: '#FFE0E6',
              data: [dataArray[0].neg, dataArray[1].neg, dataArray[2].neg, dataArray[3].neg]
            },
            {
              label: 'neu',
              backgroundColor: '#BDBCC3',
              borderColor: '#BDBCC3',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFF5DD',
              hoverBorderColor: '#FFF5DD',
              data: [dataArray[0].neu, dataArray[1].neu, dataArray[2].neu, dataArray[3].neu]
            },
            {
              label: 'pos',
              backgroundColor: '#CCF1F0',
              borderColor: '#CCF1F0',
              borderWidth: 1,
              stack: '2',
              hoverBackgroundColor: '#DBF2F2',
              hoverBorderColor: '#DBF2F2',
              data: [dataArray[0].pos, dataArray[1].pos, dataArray[2].pos, dataArray[3].pos]
            }
            ]
          }
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: false,
            legend: {
              labels: {
                fontSize: 10
              }
            },
            scales: {
              xAxes: [{
                stacked: true,
                gridLines: {
                  offsetGridLines: true
                },
                ticks: {
                  scaleBeginAtZero: false,
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Nivel de ingreso'
                }
              }],
              yAxes: [{
                stacked: false,
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Proporción del total'
                }
              }]
            }
          } 
          
        return <Bar data={data} options={options}/>
        case 'SentimientoProm_GrupoEdad':
        for (let x in type.data){
          labelArray.push(x)
          dataArray.push(type.data[x].Sentiment.toFixed(4))
        }
        data = {
          labels: [labelArray[3], labelArray[1], labelArray[0], labelArray[2]],
          datasets: [
            {
            label: [labelArray[3], labelArray[1], labelArray[0], labelArray[2]],
            data: [dataArray[3], dataArray[1], dataArray[0], dataArray[2]],
            backgroundColor: [
              '#E87DA2',
              '#3DBAB3',
              '#80698F',
              '#9EB4B6'
            ],
            hoverBackgroundColor: [
              '#E87DA2',
              '#3DBAB3',
              '#80698F',
              '#9EB4B6'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          legend: {
            display: false,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Edad'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Sentimiento promedio'
              }
            }]
          }
        }

        return <Bar data={data} options={options}/>
        case 'SentimientoProm_Region':
        for (let x in type.data){
          labelArray.push(x)
          dataArray.push(type.data[x].Sentiment.toFixed(4))
        }
        data = {
          labels: [labelArray[3], labelArray[4], labelArray[1], labelArray[0], labelArray[2]],
          datasets: [
            {
            label: false,
            data: [dataArray[3], dataArray[4], dataArray[1], dataArray[0], dataArray[2]],
            backgroundColor: [
              '#E87DA2',
              '#3DBAB3',
              '#80698F',
              '#9EB4B6',
              '#B493A8'
              
            ],
            hoverBackgroundColor: [
              '#E87DA2',
              '#3DBAB3',
              '#80698F',
              '#9EB4B6',
              '#B493A8'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          fullWidth: true,
          legend: {
            display: false,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Región'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Sentimiento promedio'
              }
            }]
          }
        }
        return <Bar data={data} options={options}/>
        case 'SentimientoProm_Rango_Ingreso':
        for (let x in type.data){
          labelArray.push(x)
          dataArray.push(type.data[x].Sentiment.toFixed(4))
        }
        data = {
          labels: [labelArray[3], labelArray[0], labelArray[1], labelArray[2]],
          datasets: [
            {
            label: false,
            data: [dataArray[3], dataArray[0], dataArray[1], dataArray[2]],
            backgroundColor: [
              // '#E87DA2',
              '#3DBAB3',
              '#80698F',
              '#9EB4B6',
              '#B493A8'
            ],
            hoverBackgroundColor: [
              // '#E87DA2',
              '#3DBAB3',
              '#80698F',
              '#9EB4B6',
              '#B493A8'
            ]
          }]
        };
        options = {
          maintainAspectRatio: false,
          fullWidth: true,
          legend: {
            display: false,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Nivel de ingreso'
              }
            }],
            yAxes: [{
              ticks: {
                fontSize: 11
              },
              scaleLabel: {
                display: true,
                labelString: 'Sentimiento promedio'
              }
            }]
          }
        }
        return <Bar data={data} options={options}/>
        case 'TrendSemaforo1':
          verde = type.data.filter(element => element.Semaforo ==="Verde");
          amarillo = type.data.filter(element => element.Semaforo ==="Amarillo");
          rojo = type.data.filter(element => element.Semaforo ==="Rojo");
          labelArray=[verde[0].ngram, verde[1].ngram, verde[2].ngram]
          data = {
            labels: labelArray,
            datasets: [
              {
              label: 'V',
              backgroundColor: '#CCF1F0',
              borderColor: '#CCF1F0',
              borderWidth: 1,
              stack: '1',
              hoverBackgroundColor: '#DBF2F2',
              hoverBorderColor: '#DBF2F2',
              data: [verde[0].freq, verde[1].freq, verde[2].freq]
            },
            {
              label: 'A',
              backgroundColor: '#BDBCC3',
              borderColor: '#BDBCC3',
              borderWidth: 1,
              stack: '2',
              hoverBackgroundColor: '#FFF5DD',
              hoverBorderColor: '#FFF5DD',
              data: [amarillo[0].freq, amarillo[1].freq, amarillo[2].freq]
            },
            {
              label: 'R',
              backgroundColor: '#F2D7E1',
              borderColor: '#F2D7E1',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFE0E6',
              hoverBorderColor: '#FFE0E6',
              data: [rojo[0].freq, rojo[1].freq, rojo[2].freq],
            }]
          }
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: true,
            legend: {
              display:true,
              labels: {
                fontSize: 10
              }
          },
            scales: {
              xAxes: [{
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Palabra'
                }
              }],
              yAxes: [{
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Sentimiento promedio, conteo'
                }
              }]
            }
          }
        return <Bar data={data} options={options}/>
        case 'TrendSemaforo2':
          verde = type.data.filter(element => element.Semaforo ==="Verde");
          amarillo = type.data.filter(element => element.Semaforo ==="Amarillo");
          rojo = type.data.filter(element => element.Semaforo ==="Rojo");

          labelArray=[verde[0].ngram, verde[1].ngram, verde[2].ngram]
          
          data = {
            labels: labelArray,
            datasets: [
              {
              label: 'V',
              backgroundColor: '#CCF1F0',
              borderColor: '#CCF1F0',
              borderWidth: 1,
              stack: '1',
              hoverBackgroundColor: '#DBF2F2',
              hoverBorderColor: '#DBF2F2',
              data: [verde[0].freq, verde[1].freq, verde[2].freq]
            },
            {
              label: 'A',
              backgroundColor: '#BDBCC3',
              borderColor: '#BDBCC3',
              borderWidth: 1,
              stack: '2',
              hoverBackgroundColor: '#FFF5DD',
              hoverBorderColor: '#FFF5DD',
              data: [amarillo[0].freq, amarillo[1].freq, amarillo[2].freq]
            },
            {
              label: 'R',
              backgroundColor: '#F2D7E1',
              borderColor: '#F2D7E1',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFE0E6',
              hoverBorderColor: '#FFE0E6',
              data: [rojo[0].freq, rojo[1].freq, rojo[2].freq],
            }]
          }
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: true,
            legend: {
              display:true,
              labels: {
                fontSize: 10
              }
          },
            scales: {
              xAxes: [{
                ticks: {
                  fontSize: 7
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Par de palabras'
                }
              }],
              yAxes: [{
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Sentimiento promedio, conteo'
                }
              }]
            }
          }
        
        return <Bar data={data} options={options}/>
        case 'TrendSemaforo4':
          verde = type.data.filter(element => element.Semaforo ==="Verde");
          amarillo = type.data.filter(element => element.Semaforo ==="Amarillo");
          rojo = type.data.filter(element => element.Semaforo ==="Rojo");

          // labelArray=[verde[0].ngram, verde[1].ngram, verde[2].ngram]
          labelArray=[verde[0].ngram.slice(0,21), verde[1].ngram.slice(0,21), verde[2].ngram.slice(0,21)]
          
          data = {
            labels: labelArray,
            datasets: [
              {
              label: 'V',
              backgroundColor: '#F2D7E1',
              borderColor: '#F2D7E1',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFE0E6',
              hoverBorderColor: '#FFE0E6',
              data: [verde[0].freq, verde[1].freq, verde[2].freq]
            },
            {
              label: 'A',
              backgroundColor: '#BDBCC3',
              borderColor: '#BDBCC3',
              borderWidth: 1,
              stack: '2',
              hoverBackgroundColor: '#FFF5DD',
              hoverBorderColor: '#FFF5DD',
              data: [amarillo[0].freq, amarillo[1].freq, amarillo[2].freq]
            },
            {
              label: 'R',
              backgroundColor: '#F2D7E1',
              borderColor: '#F2D7E1',
              borderWidth: 1,
              stack: '3',
              hoverBackgroundColor: '#FFE0E6',
              hoverBorderColor: '#FFE0E6',
              data: [rojo[0].freq, rojo[1].freq, rojo[2].freq],
            }]
          }
          options = {
            maintainAspectRatio: false,
            responsive: true,
            borderSkipped: true,
            legend: {
              display:true,
              labels: {
                fontSize: 10
              }
          },
            scales: {
              xAxes: [{
                ticks: {
                  fontSize: 6
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Ideas'
                }
              }],
              yAxes: [{
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Sentimiento promedio, conteo'
                }
              }]
            }
          }
        
        return <Bar data={data} options={options}/>
        case 'TrendGeneral_Bars':
          type.data.map(element => {
            if(element.n === 1 || element.n === 2) {
              while(labelArray.length < 19){
                labelArray.push(element.ngram)
                dataArray.push(element.freq)
                return;
              }
              limit--
            }
          })
          data = {
            labels: labelArray,
            datasets: [{
              data: dataArray,
              backgroundColor: [
                '#C72544',
                '#C92D4B',
                '#CB3653',
                '#CD3E5A',
                '#CF4863',
                '#D14F69',
                '#D35A73',
                '#D56078',
                '#D86C82',
                '#DC7E92',
                '#D97187',
                '#E08FA2',
                '#E193A5',
                '#E5A1B1',
                '#E9B3C1',
                '#EBBDCA',
                '#EDC5D1',
                '#EDC6D2',
                '#F2D7E1',
                '#EDC6D2',
                '#F2D7E1'
              ],
              hoverBackgroundColor: [
                '#C72544',
                '#C92D4B',
                '#CB3653',
                '#CD3E5A',
                '#CF4863',
                '#D14F69',
                '#D35A73',
                '#D56078',
                '#D86C82',
                '#DC7E92',
                '#D97187',
                '#E08FA2',
                '#E193A5',
                '#E5A1B1',
                '#E9B3C1',
                '#EBBDCA',
                '#EDC5D1',
                '#EDC6D2',
                '#F2D7E1',
                '#EDC6D2',
                '#F2D7E1'
              ]
            }]
          };
          options = {
            maintainAspectRatio: false,
            responsive: true,
            fullwidth: true,
            legend: {
              display:false,
              labels: {
                fontSize: 10
              }
          },
            scales: {
              xAxes: [{
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Ideas'
                }
              }],
              yAxes: [{
                ticks: {
                  fontSize: 11
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Conteo'
                }
              }]
            }
          }
        return <HorizontalBar data={data} options={options}/> 
        case 'MapaCompetencia':
          getMapData = () => {
            let dataMapArray = [];
            let dataMapObject = {};
            let dataBeforeTreat = {}
            for (let x in type.data){
              dataBeforeTreat =  type.data[x]
              dataMapObject = {
                ...dataBeforeTreat,
                Region: x
              }
              dataMapArray.push(dataMapObject)
            }

            // return new Promise((resolve, reject) => {
                let noreste= dataMapArray.find(element => element.Region === "Noreste")
                let occidente= dataMapArray.find(element => element.Region === "Occidente")
                let centro= dataMapArray.find(element => element.Region === "Centro")
                let noroeste= dataMapArray.find(element => element.Region === "Noroeste")
                let sureste= dataMapArray.find(element => element.Region === "SurEste")
  
              // resolve((() => {
                 mapInfo = {
                  noreste: noreste ? noreste.Sentiment : 0,
                  occidente: occidente ? occidente.Sentiment : 0,
                  centro: centro ? centro.Sentiment : 0,
                  noroeste: noroeste ? noroeste.Sentiment : 0,
                  sureste: sureste ? sureste.Sentiment : 0,
                }

                mapInfo2 = {
                  noreste: noreste ? noreste.Oportunidad : 0,
                  occidente: occidente ? occidente.Oportunidad : 0,
                  centro: centro ? centro.Oportunidad : 0,
                  noroeste: noroeste ? noroeste.Oportunidad : 0,
                  sureste: sureste ? sureste.Oportunidad : 0,
                }

                mapInfo3 = {
                  noreste: noreste ? noreste.Competencia : 0,
                  occidente: occidente ? occidente.Competencia : 0,
                  centro: centro ? centro.Competencia : 0,
                  noroeste: noroeste ? noroeste.Competencia : 0,
                  sureste: sureste ? sureste.Competencia : 0,
                }

                mapInfo4 = {
                  noreste: noreste ? noreste.Crecimiento : 0,
                  occidente: occidente ? occidente.Crecimiento : 0,
                  centro: centro ? centro.Crecimiento : 0,
                  noroeste: noroeste ? noroeste.Crecimiento : 0,
                  sureste: sureste ? sureste.Crecimiento : 0,
                }
  
                return mapInfo
              // })())
            // })
          }
          getMapData()
          // .then(mapInfo => {
             mapData = [
              ['State', 'Sentiment', 'Oportunidad'],
              ['Baja California', mapInfo.noroeste, mapInfo2.noroeste],
              ['Sonora',  mapInfo.noroeste, mapInfo2.noroeste],
              ['Chihuahua',  mapInfo.noroeste, mapInfo2.noroeste],
              ['Coahuila', mapInfo.noreste, mapInfo2.noreste],
              ['Nuevo León', mapInfo.noreste, mapInfo2.noreste],
              ['Tamaulipas', mapInfo.noreste, mapInfo2.noreste],
              ['Sinaloa',  mapInfo.noroeste, mapInfo2.noroeste],
              ['Nayarit', mapInfo.occidente, mapInfo2.occidente],
              ['Durango', mapInfo.noreste, mapInfo2.noreste],
              ['Zacatecas', mapInfo.occidente, mapInfo2.occidente],
              ['Jalisco', mapInfo.occidente, mapInfo2.occidente],
              ['Colima', mapInfo.occidente, mapInfo2.occidente],
              ['Tlaxcala', mapInfo.centro, mapInfo2.centro],
              ['Aguascalientes', mapInfo.occidente, mapInfo2.occidente],
              ['Zacatecas', mapInfo.occidente, mapInfo2.occidente],
              ['San Luis Potosí', mapInfo.noreste, mapInfo2.noreste],
              ['Puebla', mapInfo.centro, mapInfo2.centro],
              ['Guanajuato', mapInfo.occidente, mapInfo2.occidente],
              ['Querétaro', mapInfo.occidente, mapInfo2.occidente],
              ['Hidalgo', mapInfo.centro, mapInfo2.centro],
              ['Morelos', mapInfo.centro, mapInfo2.centro],
              ['Estado de México', mapInfo.centro, mapInfo2.centro],
              ['Distrito Federal', mapInfo.centro, mapInfo2.centro],
              ['Baja California Sur', mapInfo.noroeste, mapInfo2.noroeste],
              ['Michoacán', mapInfo.occidente, mapInfo2.occidente],
              ['Guerrero', mapInfo.sureste, mapInfo2.sureste],
              ['Oaxaca', mapInfo.sureste, mapInfo2.sureste],
              ['Veracruz', mapInfo.sureste, mapInfo2.sureste],
              ['Tabasco', mapInfo.sureste, mapInfo2.sureste],
              ['Campeche',  mapInfo.sureste, mapInfo2.sureste],
              ['Chiapas', mapInfo.sureste, mapInfo2.sureste],
              ['Quintana Roo', mapInfo.sureste, mapInfo2.sureste],
              ['Yucatán', mapInfo.sureste, mapInfo2.sureste],
            ]
            mapData2 = [
              ['State', 'Competencia', 'Crecimiento'],
              ['Baja California', mapInfo3.noroeste, mapInfo4.noroeste],
              ['Sonora',  mapInfo3.noroeste, mapInfo4.noroeste],
              ['Chihuahua',  mapInfo3.noroeste, mapInfo4.noroeste],
              ['Coahuila', mapInfo3.noreste, mapInfo4.noreste],
              ['Nuevo León', mapInfo3.noreste, mapInfo4.noreste],
              ['Tamaulipas', mapInfo3.noreste, mapInfo4.noreste],
              ['Sinaloa',  mapInfo3.noroeste, mapInfo4.noroeste],
              ['Nayarit', mapInfo3.occidente, mapInfo4.occidente],
              ['Durango', mapInfo3.noreste, mapInfo4.noreste],
              ['Zacatecas', mapInfo3.occidente, mapInfo4.occidente],
              ['Jalisco', mapInfo3.occidente, mapInfo4.occidente],
              ['Colima', mapInfo3.occidente, mapInfo4.occidente],
              ['Tlaxcala', mapInfo3.centro, mapInfo4.centro],
              ['Aguascalientes', mapInfo3.occidente, mapInfo4.occidente],
              ['Zacatecas', mapInfo3.occidente, mapInfo4.occidente],
              ['San Luis Potosí', mapInfo3.noreste, mapInfo4.noreste],
              ['Puebla', mapInfo3.centro, mapInfo4.centro],
              ['Guanajuato', mapInfo3.occidente, mapInfo4.occidente],
              ['Querétaro', mapInfo3.occidente, mapInfo4.occidente],
              ['Hidalgo', mapInfo3.centro, mapInfo4.centro],
              ['Morelos', mapInfo3.centro, mapInfo4.centro],
              ['Estado de México', mapInfo3.centro, mapInfo4.centro],
              ['Distrito Federal', mapInfo3.centro, mapInfo4.centro],
              ['Baja California Sur', mapInfo3.noroeste, mapInfo4.noroeste],
              ['Michoacán', mapInfo3.occidente, mapInfo4.occidente],
              ['Guerrero', mapInfo3.sureste, mapInfo4.sureste],
              ['Oaxaca', mapInfo3.sureste, mapInfo4.sureste],
              ['Veracruz', mapInfo3.sureste, mapInfo4.sureste],
              ['Tabasco', mapInfo3.sureste, mapInfo4.sureste],
              ['Campeche',  mapInfo3.sureste, mapInfo4.sureste],
              ['Chiapas', mapInfo3.sureste, mapInfo4.sureste],
              ['Quintana Roo', mapInfo3.sureste, mapInfo4.sureste],
              ['Yucatán', mapInfo3.sureste, mapInfo4.sureste],
            ]
          // })
          return !mapData ? <div>Loading...</div> :
           <Chart
            width={'300px'}
            height={'180px'}
            chartType="GeoChart"
            // data={{...mapData}}
            data={[...mapData],[...mapData2]}
            options={{
              fill:'#FBFEFE',
              region: 'MX', // Mexico
              resolution: 'provinces',
              colorAxis: {
                //     	minValue=100,
                //     maxValue=400,
                values: [0, 1, 2, 3, 4, 5],
                colors: ['#EEEEEE', '#EFB2C7', '#E999B5', '#DF668F', '#DF3870', '#DF3870']
              },
              backgroundColor: '#f4f2f2',
              datalessRegionColor: '#eeeeee',
              defaultColor: '#f5f5f5',
              // sizeAxis: { minValue: 0, maxValue: 100 },
              // region: '155', // Western Europe
              // displayMode: 'markers',
              // colorAxis: { colors: ['#e7711c', '#4374e0'] }, // orange to blue
            }}
            // Note: you will need to get a mapsApiKey for your project.
            // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
            mapsApiKey="YOUR_KEY_HERE"
            rootProps={{ 'data-testid': '3' }}
          />
          break;
          case 'Trend_Region_Map':
            getMapData = () => {
              let dataMapArray = [
                {
                  Region: "Centro",
                  data: []
                },
                {
                  Region: "Noreste",
                  data: []
                },
                {
                  Region: "Noroeste",
                  data: []
                },
                {
                  Region: "Occidente",
                  data: []
                },
                {
                  Region: "SurEste",
                  data: []
                },
            ];
              let dataMapObject = {};
              let dataBeforeTreat = {}
              type.data.map(element => {
                if(element.Region === "Centro"){
                 if(element.n === 0){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  } else if(element.n === 1){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  } else if(element.n === 2){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  }
                   else if(element.n === 4){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  }
                } else if(element.Region === "Noreste"){
                 if(element.n === 0){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  } else  if(element.n === 1){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[1].data.push(dataMapObject)
                  } else if(element.n === 2){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[1].data.push(dataMapObject)
                  }
                   else if(element.n === 4){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[1].data.push(dataMapObject)
                  }
                } else if(element.Region === "Noroeste"){
                 if(element.n === 0){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  } else  if(element.n === 1){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[2].data.push(dataMapObject)
                  } else if(element.n === 2){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[2].data.push(dataMapObject)
                  }
                   else if(element.n === 4){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[2].data.push(dataMapObject)
                  }
                } else if(element.Region === "Occidente"){
                 if(element.n === 0){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  } else  if(element.n === 1){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[3].data.push(dataMapObject)
                  } else if(element.n === 2){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[3].data.push(dataMapObject)
                  }
                   else if(element.n === 4){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[3].data.push(dataMapObject)
                  }
                } else if(element.Region === "SurEste"){
                 if(element.n === 0){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[0].data.push(dataMapObject)
                  } else  if(element.n === 1){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[4].data.push(dataMapObject)
                  } else if(element.n === 2){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[4].data.push(dataMapObject)
                  }
                   else if(element.n === 4){
                    dataMapObject = {
                      n: element.n,
                      ngram: element.ngram,
                      freq: element.freq
                    }
                    dataMapArray[4].data.push(dataMapObject)
                  }
                }
              })

              // for (let x in type.data){
              //   dataBeforeTreat =  type.data[x]
              //   dataMapObject = {
              //     ...dataBeforeTreat,
              //     Region: x
              //   }
              //   dataMapArray.push(dataMapObject)
              // }
              // return new Promise((resolve, reject) => {
                  let noreste= dataMapArray.find(element => element.Region === "Noreste")
                  let occidente= dataMapArray.find(element => element.Region === "Occidente")
                  let centro= dataMapArray.find(element => element.Region === "Centro")
                  let noroeste= dataMapArray.find(element => element.Region === "Noroeste")
                  let sureste= dataMapArray.find(element => element.Region === "SurEste")

                   mapInfo = {
                    noreste: noreste.data.length >0 ? {"1": noreste.data[0].ngram, "3": noreste.data[1].ngram} : '',
                    occidente: occidente.data.length >0 ? {"1": occidente.data[0].ngram, "3": occidente.data[1].ngram} : '',
                    centro: centro.data.length >0 ? {"1": centro.data[0].ngram, "3": centro.data[1].ngram} : '',
                    noroeste: noroeste.data.length >0 ? {"1": noroeste.data[0].ngram, "3": noroeste.data[1].ngram} : '',
                    sureste: sureste.data.length >0 ? {"1": sureste.data[0].ngram, "3": sureste.data[1].ngram} : '',
                  }
  
                  mapInfo2 = {
                    noreste: noreste.data.length >0 ? {"1": noreste.data[0].freq, "3": noreste.data[1].freq} : '',
                    occidente: occidente.data.length >0 ? {"1": occidente.data[0].freq, "3": occidente.data[1].freq} : '',
                    centro: centro.data.length >0 ? {"1": centro.data[0].freq, "3": centro.data[1].freq} : '',
                    noroeste: noroeste.data.length >0 ? {"1": noroeste.data[0].freq, "3": noroeste.data[1].freq} : '',
                    sureste: sureste.data.length >0 ? {"1": sureste.data[0].freq, "3": sureste.data[1].freq} : '',
                    // noreste: noreste.data.length >0 ? noreste.data.freq : 0,
                    // occidente: occidente.data.length >0 ? occidente.data.freq : 0,
                    // centro: centro.data.length >0 ? centro.data.freq : 0,
                    // noroeste: noroeste.data.length >0 ? noroeste.data.freq : 0,
                    // sureste: sureste.data.length >0 ? sureste.data.freq : 0,
                  }
  
                  mapInfo3 = {
                    noreste: noreste.data.length >0 ? noreste.data.n : 0,
                    occidente: occidente.data.length >0 ? occidente.data.n : 0,
                    centro: centro.data.length >0 ? centro.data.n : 0,
                    noroeste: noroeste.data.length >0 ? noroeste.data.n : 0,
                    sureste: sureste.data.length >0 ? sureste.data.n : 0,
                  }
  
                  // mapInfo4 = {
                  //   noreste: noreste ? noreste.Crecimiento : 0,
                  //   occidente: occidente ? occidente.Crecimiento : 0,
                  //   centro: centro ? centro.Crecimiento : 0,
                  //   noroeste: noroeste ? noroeste.Crecimiento : 0,
                  //   sureste: sureste ? sureste.Crecimiento : 0,
                  // }
                  return mapInfo
                // })())
              // })
            }
            getMapData()
            // .then(mapInfo => {
               mapData = [
                ['State', 'ngram', 'frecuencia'],
                ['Baja California', mapInfo.noroeste["1"], mapInfo2.noroeste["1"]],
                ['Sonora',  mapInfo.noroeste["1"], mapInfo2.noroeste["1"]],
                ['Chihuahua',  mapInfo.noroeste["1"], mapInfo2.noroeste["1"]],
                ['Coahuila', mapInfo.noreste["1"], mapInfo2.noreste["1"]],
                ['Nuevo León', mapInfo.noreste["1"], mapInfo2.noreste["1"]],
                ['Tamaulipas', mapInfo.noreste["1"], mapInfo2.noreste["1"]],
                ['Sinaloa',  mapInfo.noroeste["1"], mapInfo2.noroeste["1"]],
                ['Nayarit', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Durango', mapInfo.noreste["1"], mapInfo2.noreste["1"]],
                ['Zacatecas', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Jalisco', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Colima', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Tlaxcala', mapInfo.centro["1"], mapInfo2.centro["1"]],
                ['Aguascalientes', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Zacatecas', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['San Luis Potosí', mapInfo.noreste["1"], mapInfo2.noreste["1"]],
                ['Puebla', mapInfo.centro["1"], mapInfo2.centro["1"]],
                ['Guanajuato', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Querétaro', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Hidalgo', mapInfo.centro["1"], mapInfo2.centro["1"]],
                ['Morelos', mapInfo.centro["1"], mapInfo2.centro["1"]],
                ['Estado de México', mapInfo.centro["1"], mapInfo2.centro["1"]],
                ['Distrito Federal', mapInfo.centro["1"], mapInfo2.centro["1"]],
                ['Baja California Sur', mapInfo.noroeste["1"], mapInfo2.noroeste["1"]],
                ['Michoacán', mapInfo.occidente["1"], mapInfo2.occidente["1"]],
                ['Guerrero', mapInfo.sureste["1"], mapInfo2.sureste["1"]],
                ['Oaxaca', mapInfo.sureste["1"], mapInfo2.sureste["1"]],
                ['Veracruz', mapInfo.sureste["1"], mapInfo2.sureste["1"]],
                ['Tabasco', mapInfo.sureste["1"], mapInfo2.sureste["1"]],
                ['Campeche',  mapInfo.sureste["1"], mapInfo2.sureste["1"]],
                ['Chiapas', mapInfo.sureste["1"], mapInfo2.sureste["1"]],
                ['Quintana Roo', mapInfo.sureste["1"], mapInfo2.sureste["1"]],
                ['Yucatán', mapInfo.sureste["1"], mapInfo2.sureste["1"]],
              ]
              // mapData2 = [
              //   ['State', 'Competencia', 'Crecimiento'],
              //   ['Baja California', mapInfo3.noroeste, mapInfo4.noroeste],
              //   ['Sonora',  mapInfo3.noroeste, mapInfo4.noroeste],
              //   ['Chihuahua',  mapInfo3.noroeste, mapInfo4.noroeste],
              //   ['Coahuila', mapInfo3.noreste, mapInfo4.noreste],
              //   ['Nuevo León', mapInfo3.noreste, mapInfo4.noreste],
              //   ['Tamaulipas', mapInfo3.noreste, mapInfo4.noreste],
              //   ['Sinaloa',  mapInfo3.noroeste, mapInfo4.noroeste],
              //   ['Nayarit', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Durango', mapInfo3.noreste, mapInfo4.noreste],
              //   ['Zacatecas', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Jalisco', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Colima', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Tlaxcala', mapInfo3.centro, mapInfo4.centro],
              //   ['Aguascalientes', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Zacatecas', mapInfo3.occidente, mapInfo4.occidente],
              //   ['San Luis Potosí', mapInfo3.noreste, mapInfo4.noreste],
              //   ['Puebla', mapInfo3.centro, mapInfo4.centro],
              //   ['Guanajuato', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Querétaro', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Hidalgo', mapInfo3.centro, mapInfo4.centro],
              //   ['Morelos', mapInfo3.centro, mapInfo4.centro],
              //   ['Estado de México', mapInfo3.centro, mapInfo4.centro],
              //   ['Distrito Federal', mapInfo3.centro, mapInfo4.centro],
              //   ['Baja California Sur', mapInfo3.noroeste, mapInfo4.noroeste],
              //   ['Michoacán', mapInfo3.occidente, mapInfo4.occidente],
              //   ['Guerrero', mapInfo3.sureste, mapInfo4.sureste],
              //   ['Oaxaca', mapInfo3.sureste, mapInfo4.sureste],
              //   ['Veracruz', mapInfo3.sureste, mapInfo4.sureste],
              //   ['Tabasco', mapInfo3.sureste, mapInfo4.sureste],
              //   ['Campeche',  mapInfo3.sureste, mapInfo4.sureste],
              //   ['Chiapas', mapInfo3.sureste, mapInfo4.sureste],
              //   ['Quintana Roo', mapInfo3.sureste, mapInfo4.sureste],
              //   ['Yucatán', mapInfo3.sureste, mapInfo4.sureste],
              // ]
            // })
            return !mapData ? <div>Loading...</div> :
             <Chart
              width={'300px'}
              height={'180px'}
              chartType="GeoChart"
              // data={{...mapData}}
              data={mapData}
              options={{
                fill:'#FBFEFE',
                region: 'MX', // Mexico
                resolution: 'provinces',
                colorAxis: {
                  //     	minValue=100,
                  //     maxValue=400,
                  values: [0, 10, 20, 30, 40, 50],
                  colors: ['#EEEEEE', '#EFB2C7', '#E999B5', '#DF668F', '#DF3870', '#DF3870']
                },
                backgroundColor: '#f4f2f2',
                datalessRegionColor: '#eeeeee',
                defaultColor: '#f5f5f5',
                // sizeAxis: { minValue: 0, maxValue: 100 },
                // region: '155', // Western Europe
                // displayMode: 'markers',
                // colorAxis: { colors: ['#e7711c', '#4374e0'] }, // orange to blue
              }}
              // Note: you will need to get a mapsApiKey for your project.
              // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
              mapsApiKey="YOUR_KEY_HERE"
              rootProps={{ 'data-testid': '3' }}
            />
            break;
            case 'Precios_Stats':
              // let i = 0;
              // let allPices = []
              for (let x in type.data){
                // i++
                // allPrices.push()
                if(type.data[x].Price_new != null){
                  price_list.push(type.data[x].Price_new)
                }
                if(type.data[x].Sentiment !== null){
                  labelArray.push(x)
                  dataArray.push(type.data[x].Sentiment)
                  dataArray2.push(price_list[price_list.length - 1])
                }
              }
      
              data = {
                labels: labelArray,
                datasets: [{
                  fill: false,
                  label: 'Sentimiento',
                  yAxisID: 'Sentimiento',
                  // lineTension: 0.1,
                  // backgroundColor: 'rgba(75,192,192)',
                  borderColor: '#C72544',
                  // borderCapStyle: 'butt',
                  // borderDash: [],
                  // borderDashOffset: 1.0,
                  data: dataArray,
                  hoverBackgroundColor: [
                    '#C72544',
                    // '#DF668F',
                    // '#F4CCDA'
                  ]
                },
                {
                  fill: false,
                  steppedLine: true,
                  label: 'Precio',
                  yAxisID: 'Precio',
                  // lineTension: 0.1,
                  // backgroundColor: 'rgba(75,192,192)',
                  borderColor: '#3DBAB3',
                  // borderCapStyle: 'butt',
                  // borderDash: [],
                  // borderDashOffset: 1.0,
                  data: dataArray2,
                  hoverBackgroundColor: [
                    // '#3DBAB3',
                    // '#DF668F',
                    '#3DBAB3'
                  ]
                }]
              }
              options = {
                maintainAspectRatio: false,
                responsive: true,
                borderSkipped: true,
                legend: {
                  display:true,
                  labels: {
                    fontSize: 10
                  }
              },
                scales: {
                  xAxes: [{
                    ticks: {
                      fontSize: 9
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Fecha'
                    }
                  }],
                  yAxes: [{
                    id: 'Sentimiento',
                    type: 'linear',
                    position: 'left',
                    ticks: {
                      fontSize: 9,
                      max: Math.max.apply(Math, dataArray),
                      min: Math.min.apply(Math, dataArray),
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Sentimiento promedio'
                    }
                  },
                  {
                    id: 'Precio',
                    type: 'linear',
                    position: 'right',
                    ticks: {
                      fontSize: 11,
                      max: Math.max.apply(Math, price_list),
                      min: Math.min.apply(Math, price_list),
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Precio promedio'
                    }
                  }]
                }
              }
              
              return <Line data={data} options={options}/>
      case 'Precios_Stats_Conteo':
        
        // let allPices = []
        for (let x in type.data){
          
          // allPrices.push()
          if(type.data[x].Price_new != null){
            price_list.push(type.data[x].Price_new)
          }
          if(type.data[x].Sentiment !== null){
            labelArray.push(x)
            dataArray.push(type.data[x].Conteo)
            dataArray2.push(price_list[price_list.length - 1])
          }
        }

        data = {
          labels: labelArray,
          datasets: [{
            fill: false,
            label: 'Conteo',
            yAxisID: 'Conteo',
            // lineTension: 0.1,
            // backgroundColor: 'rgba(75,192,192)',
            borderColor: '#C72544',
            // borderCapStyle: 'butt',
            // borderDash: [],
            // borderDashOffset: 1.0,
            data: dataArray,
            hoverBackgroundColor: [
              '#C72544',
              // '#DF668F',
              // '#F4CCDA'
            ]
          },
          {
            fill: false,
            steppedLine: true,
            label: 'Precio',
            yAxisID: 'Precio',
            // lineTension: 0.1,
            // backgroundColor: 'rgba(75,192,192)',
            borderColor: '#3DBAB3',
            // borderCapStyle: 'butt',
            // borderDash: [],
            // borderDashOffset: 1.0,
            data: dataArray2,
            hoverBackgroundColor: [
              // '#3DBAB3',
              // '#DF668F',
              '#F4CCDA'
            ]
          }]
        }
        options = {
          maintainAspectRatio: false,
          responsive: true,
          borderSkipped: true,
          legend: {
            display:true,
            labels: {
              fontSize: 10
            }
        },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 9
              },
              scaleLabel: {
                display: true,
                labelString: 'Fecha'
              }
            }],
            yAxes: [{
              id: 'Conteo',
              type: 'linear',
              position: 'left',
              ticks: {
                fontSize: 9,
                max: Math.max.apply(Math, dataArray),
                min: Math.min.apply(Math, dataArray),
              },
              scaleLabel: {
                display: true,
                labelString: 'Volumen de comentarios'
              }
            },
            {
              id: 'Precio',
              type: 'linear',
              position: 'right',
              ticks: {
                fontSize: 11,
                max: Math.max.apply(Math, price_list),
                min: Math.min.apply(Math, price_list),
              },
              scaleLabel: {
                display: true,
                labelString: 'Precio promedio'
              }
            }]
          }
        }
        // options = {
        //   scales: {
        //     yAxes: [{
        //       id: 'Conteo',
        //       type: 'linear',
        //       position: 'left',
        //       ticks: {
        //         max: Math.max.apply(Math, dataArray),
        //         min: Math.min.apply(Math, dataArray),
        //         fontSize: 8
        //       }
        //     }, {
        //       id: 'Precio',
        //       type: 'linear',
        //       position: 'right',
        //       ticks: {
        //         max: Math.max.apply(Math, price_list),
        //         min: Math.min.apply(Math, price_list),
        //         fontSize: 8
                
        //       }
        //     }]
        //   },
        //   // legend: {
        //   //   labels: {
        //   //       fontSize: 7,
        //   //       fontColor: 'black'
        //   //   }
        //   // }
        // }
        // { maintainAspectRatio: false }
        return <Line data={data} options={options}/>
        default:
          break;
      }
    }else {
      return <div>No hay información</div>
    }
    
  }
  
  return (
    <GMMain>
      { checkGraphKind(data) }
    </GMMain>
  );
}

  export default GraphMasterDouble;